import { render, staticRenderFns } from "./PortalHelp.vue?vue&type=template&id=f376e276&"
import script from "./PortalHelp.vue?vue&type=script&lang=js&"
export * from "./PortalHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports